import { Extension } from "@tiptap/core";

const FONTS = [
  "ql-font-roboto",
  "ql-font-manrope",
  "ql-font-serif",
  "ql-font-sansserif",
  "ql-font-monospace",
  "ql-font-abrilfatface",
];

export const Fonts = Extension.create({
  name: "fonts",

  addOptions() {
    return {
      types: ["textStyle"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          font: {
            default: null,
            parseHTML: (element) => {
              for (let i = 0; i < element.classList.length; i++) {
                const className = element.classList[i];
                if (FONTS.includes(className)) {
                  return className;
                }
              }
              return null;
            },
            renderHTML: (attributes) => {
              return attributes.font ? { class: attributes.font } : {};
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFont: (font) => ({ chain }) => {
        return chain().setMark("textStyle", { font }).run();
      },
    };
  },
});
